

export const initialState = {

}

export const rootReducer = (state = initialState, action) =>{
    switch (action.type) {
    
        default:
            return {...state}
    }
}

export default rootReducer;